import { FC } from "react";

import { copy } from "shared/assets";
import { Bus, Plane, Plus, Train } from "shared/assets/icons";
import { Button, ButtonContainer } from "shared/components";
import { Icon } from "shared/styles";
import { ITheme } from "shared/types";

const travelLegCopy = copy.travelBlock.travelLeg;

interface Props {
  handleAddFlight: () => void;
  handleAddBus: () => void;
  handleAddTrain: () => void;
  handleAddOther: () => void;
}

export const AddTravelLegButtons: FC<Props> = ({
  handleAddFlight,
  handleAddBus,
  handleAddTrain,
  handleAddOther,
}) => {
  return (
    <ButtonContainer>
      <Button
        onClick={handleAddFlight}
        theme={ITheme.secondary}
        size="s"
        data-testid="add_flight"
      >
        <Icon as={Plane} />
        <span>{travelLegCopy.buttons.addFlight}</span>
      </Button>
      <Button
        onClick={handleAddBus}
        theme={ITheme.secondary}
        size="s"
        data-testid="add_bus"
      >
        <Icon as={Bus} />
        <span>{travelLegCopy.buttons.addBus}</span>
      </Button>
      <Button
        onClick={handleAddTrain}
        theme={ITheme.secondary}
        size="s"
        data-testid="add_train"
      >
        <Icon as={Train} />
        <span>{travelLegCopy.buttons.addTrain}</span>
      </Button>
      <Button
        onClick={handleAddOther}
        theme={ITheme.secondary}
        size="s"
        data-testid="add_other"
      >
        <Icon as={Plus} />
        <span>{travelLegCopy.buttons.addOther}</span>
      </Button>
    </ButtonContainer>
  );
};
